export const PATH_VALIDATION_REGEX = '^(/|[a-zA-Z]:\\\\).*$';
